import { useTranslation } from '@/hooks/useTranslation';
import { parseMarkdown } from '@/utils/Markdown/parseMarkdown';
import i18next from "i18next";
import isEqual from 'lodash/isEqual';
import isString from 'lodash/isString';
import { memo } from 'react';
import { useTranslation as usei18NTranslation } from 'react-i18next';

export const Translate = memo(({ text = null, id = false, linebreaks = true, lang = i18next.language, options = [], translateOptions = false }) => {
    usei18NTranslation();

    const {
        translate, 
        translateByKey,
    } = useTranslation();

    const translatedString = isString(id) ? translateByKey(id, options, translateOptions) : translate(text, translateOptions);

    if (linebreaks === false) {
        const withoutLinesBreaks = translatedString?.replace(/(\r\n|\n|\r)/gm, " ");
        return parseMarkdown(withoutLinesBreaks);
    }
    
    return parseMarkdown(translatedString);
}, isEqual);